import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {getSessionStorageItem, removeSessionStorageItem} from "../../../misc/storageFunctions";
import {setAdminLoginPopupVisible, setAdminLogoutVisible} from "./adminActions";


const SuperAdminLoginButton = (props) => {

  const {setAdminLoginPopupVisible, adminLogoutVisible, setAdminLogoutVisible} = props;

  const isLoggedAsAdmin = getSessionStorageItem("superAdminToken",  false);

  const handleLogOutButtonClick = (logout) => {
    if (logout) {
      removeSessionStorageItem("superAdminToken");
    }
    setAdminLogoutVisible(false);
  }

  const handleUserLoginClick = () => {
    if (isLoggedAsAdmin) {
      setAdminLogoutVisible(true);
    } else {
      setAdminLoginPopupVisible(true);
    }
  }

  return (
    <div className="materials-buttonWrapper">
      <button
        className={"materials-button materials-button--user" + (adminLogoutVisible ? " materials-button--active" : "")}
        onClick={handleUserLoginClick}>
          <span className="materials-button__text">
            {isLoggedAsAdmin
              ? <FormattedMessage id={"userLoginButton.logOut"}/>
              : <FormattedMessage id={"userLoginButton.logIn"}/>}
          </span>
      </button>
      <div className={"scart-dropdown" + (adminLogoutVisible ? " scart-dropdown--opened" : "")}>
        <div className="scart-content__question">
          <p className="scart-content__question-text"><FormattedMessage id={"userLoginButton.logoutQuestion"}/></p>
          <div className="scart-content__question-buttons">
            <button className="ui-button2 ui-button2--white" onClick={() => handleLogOutButtonClick(true)}>
              <FormattedMessage id={"userLoginButton.logoutQuestionYes"}/>
            </button>
            <button className="ui-button2 ui-button2--white" onClick={() => handleLogOutButtonClick(false)}>
              <FormattedMessage id={"userLoginButton.logoutQuestionNo"}/>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {adminLoginPopupVisible, adminLogoutVisible} = store.adminState;
  return {
    adminLoginPopupVisible,
    adminLogoutVisible,
  };
};

const mapDispatchToProps = {
  setAdminLoginPopupVisible,
  setAdminLogoutVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminLoginButton)
